module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-startseite-hintergrund-aeee79cdb8096d39bb5fbc14ae4a57a7.jpg";